import posthog from 'posthog-js'

if (gon.global.posthog_api_key) {
  posthog.init(gon.global.posthog_api_key, {
    api_host: 'https://us.i.posthog.com',
    autocapture: false,
    capture_pageview: false,
    session_recording: {
      maskAllInputs: false,
      person_profiles: 'always',
      maskInputOptions: {
        password: true
      }
    },
    loaded: function(posthog) {
      if (gon.current_user) {
        posthog.identify(gon.current_user.id, {
          email: gon.current_user.email,
          name: gon.current_user.name,
          user_id: gon.current_user.id
        });
      }
    }
  });
} else {
  console.warn('PostHog API key not found in meta tag')
}

export default posthog